import { AlertService } from './../services/alert.service';
import { ListingStorage } from './listing-storage';
import { EventService } from '../services/event.service';
import { TRANSLATE } from './translatable';

export class NavStorage {
    lot: ListingStorage;
    batiment: ListingStorage;
    prospect: ListingStorage;
    locataire: ListingStorage;
    proprietaire: ListingStorage;
    contact: ListingStorage;
    tache: ListingStorage;
    reset: boolean;


    constructor(
        private alertService: AlertService,
        data?: any
    ) {
        this.reset = false;
        this.initStorage(data);
    }

    private initStorage(data?: any) {
        if (!data) {
            data = [];
        }

        this.lot            = new ListingStorage(data['lot'] ? data['lot'] : null);
        this.batiment       = new ListingStorage(data['batiment'] ? data['batiment'] : null);
        this.prospect       = new ListingStorage(data['prospect'] ? data['prospect'] : null);
        this.locataire      = new ListingStorage(data['locataire'] ? data['locataire'] : null);
        this.proprietaire   = new ListingStorage(data['proprietaire'] ? data['proprietaire'] : null);
        this.contact        = new ListingStorage(data['contact'] ? data['contact'] : null);
        this.tache          = new ListingStorage(data['tache'] ? data['tache'] : null);
    }

    setReset(value: boolean) {
        this.reset = value;
    }

    getReset(): boolean {
        return this.reset;
    }

    private getStorageValue(storageName: string): ListingStorage {
        // Reset via navigation dans les menus du HEADER
        if (this.reset) {
            this.reset = false;
            if (this[storageName].hasActiveFilters()) {
                this.initStorage();
                this.alertService.info(TRANSLATE('Vos filtres de recherches ont été réinitialisés'), true);
            }
        }
        return this[storageName];
    }

    getLot(): ListingStorage {
        return this.getStorageValue('lot');
    }

    getBatiment(): ListingStorage {
        return this.getStorageValue('batiment');
    }

    getProspect(): ListingStorage {
        return this.getStorageValue('prospect');
    }

    getLocataire(): ListingStorage {
        return this.getStorageValue('locataire');
    }

    getProprietaire(): ListingStorage {
        return this.getStorageValue('proprietaire');
    }

    getContact(): ListingStorage {
        return this.getStorageValue('contact');
    }
    
    getTache(): ListingStorage {
        return this.getStorageValue('tache');
    }
}

